<app-panel [expanded]="isOpen" [initialWidth]="320" (close)="closePanel()">
  <div class="flex flex-col w-full">
    <app-tab [tabs]="tabs" (selectedTabIndex)="selectedTab($event)"></app-tab>
    <ng-container #tabComponentContainer></ng-container>
  </div>
</app-panel>
